import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "templates-list-form" }
const _hoisted_2 = { class: "templates-list-form_controls" }

import { computed, PropType, ref } from "vue";
import { TaskParametersTemplatesList } from "../components";
import { ParametersTemplateModel } from "../models";
import { TaskParameterModel, TaskParameterTypeEnum } from "@/components";
import { ArrowDownTrayIcon } from "tir-style-system/icons/outline";
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from "tir-components";
import { TirPmSearchInput } from "tir-pm-search-input";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'templates-list-form',
  props: {
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Список шаблонов */
  templates: { type: Array as PropType<ParametersTemplateModel[]> },
},
  emits: ["import", "editCompound", "select", "remove", "upsert"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Поисковой запрос */
const search = ref("");

/**Текст кнопки импорта */
const importButtonText = computed(() => {
  let label = "Импортировать ";

  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      label += "статусы";
      break;
    case TaskParameterTypeEnum.Priority:
      label += "приоритеты";
      break;
    case TaskParameterTypeEnum.Tag:
      label += "теги";
      break;
    case TaskParameterTypeEnum.Type:
      label += "типы";
      break;
    case TaskParameterTypeEnum.Difficulty:
      label += "сложности";
      break;
  }

  return label;
});
/**Найденные шаблона */
const searchedTemplates = computed(() => {
  const request = search.value.toLocaleLowerCase();
  if (!request) return props.templates;

  return props.templates.filter(
    (template) =>
      template.Name.toLocaleLowerCase().includes(request) ||
      template.ParsedData.some((parameter) => parameter.Name.toLocaleLowerCase().includes(request)),
  );
});

/**Открыть список параметров для импортирования */
const importParameters = () => {
  setTimeout(() => emit("import"));
};
/**Выбор параметров шаблона */
const selectParameters = (template: ParametersTemplateModel) => {
  emit("select", template.ParsedData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmSearchInput), {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        class: "templates-list-form_controls_input",
        placeholder: "",
        label: "Поиск по шаблонам",
        "is-with-popup": false
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Small,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: importParameters
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowDownTrayIcon)),
          _createTextVNode(" " + _toDisplayString(importButtonText.value), 1)
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ]),
    _createVNode(_unref(TaskParametersTemplatesList), {
      type: __props.type,
      templates: searchedTemplates.value,
      onEditCompound: _cache[1] || (_cache[1] = ($event: any) => (emit('editCompound', $event))),
      onSelect: selectParameters,
      onRemove: _cache[2] || (_cache[2] = ($event: any) => (emit('remove', $event))),
      onUpsert: _cache[3] || (_cache[3] = ($event: any) => (emit('upsert', $event)))
    }, null, 8, ["type", "templates"])
  ]))
}
}

})